import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Usama from '../Assets/Images/Clients/Hadeed img.jpg'

function Testimonials() {

    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };



  return (
    <div>
        <div className="container pt-4 pb-4">
            <div className="row g-3">
              <div className="section-header text-center">
                <h6>Echoes of Satisfaction</h6>
                <h2>Words Of Trust By Our Clients</h2>
              </div>
        <Slider {...settings}>
          <div>
            <div className="card testimonials">
                <div className="testimonials-content">
                    <img src={Usama} alt="" className="img-fluid rounded-circle w-25" />
                    <h5>M. Usama Munir</h5>
                    <p style={{fontSize: '10px'}}>Technic Mentors</p>
                    <p>Dive into a visual journey showcasing our collaborations with exceptional brands. Trusted partnerships that speak volumes through design.</p>
                </div>
            </div>
          </div>
          <div>
          <div className="card testimonials">
                <div className="testimonials-content">
                    <img src={Usama} alt="" className="img-fluid rounded-circle w-25" />
                    <h5>M. Usama Munir</h5>
                    <p style={{fontSize: '10px'}}>Technic Mentors</p>
                    <p>Dive into a visual journey showcasing our collaborations with exceptional brands. Trusted partnerships that speak volumes through design.</p>
                </div>
            </div>
          </div>
          <div>
          <div className="card testimonials">
                <div className="testimonials-content">
                    <img src={Usama} alt="" className="img-fluid rounded-circle w-25" />
                    <h5>M. Usama Munir</h5>
                    <p style={{fontSize: '10px'}}>Technic Mentors</p>
                    <p>Dive into a visual journey showcasing our collaborations with exceptional brands. Trusted partnerships that speak volumes through design.</p>
                </div>
            </div>
          </div>
          <div>
          <div className="card testimonials">
                <div className="testimonials-content">
                    <img src={Usama} alt="" className="img-fluid rounded-circle w-25" />
                    <h5>M. Usama Munir</h5>
                    <p style={{fontSize: '10px'}}>Technic Mentors</p>
                    <p>Dive into a visual journey showcasing our collaborations with exceptional brands. Trusted partnerships that speak volumes through design.</p>
                </div>
            </div>
          </div>
          <div>
          <div className="card testimonials">
                <div className="testimonials-content">
                    <img src={Usama} alt="" className="img-fluid rounded-circle w-25" />
                    <h5>M. Usama Munir</h5>
                    <p style={{fontSize: '10px'}}>Technic Mentors</p>
                    <p>Dive into a visual journey showcasing our collaborations with exceptional brands. Trusted partnerships that speak volumes through design.</p>
                </div>
            </div>
          </div>
          <div>
          <div className="card testimonials">
                <div className="testimonials-content">
                    <img src={Usama} alt="" className="img-fluid rounded-circle w-25" />
                    <h5>M. Usama Munir</h5>
                    <p style={{fontSize: '10px'}}>Technic Mentors</p>
                    <p>Dive into a visual journey showcasing our collaborations with exceptional brands. Trusted partnerships that speak volumes through design.</p>
                </div>
            </div>
          </div>
          
        </Slider>
        </div>
        </div>
    </div>
  )
}

export default Testimonials
